<template>
    <div style="height: 100%">
        <div class="sa-flexbox" style="padding-bottom: 20px">
            <div class="sa-flexbox-body">
                <div class="b-table-sticky-header">
                    <span class="sa-flexbox-body-title">Referti</span>
                    <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickNuovaReferto" class="mb-2">
                        <font-awesome-icon icon="plus"> </font-awesome-icon>
                        Aggiungi
                    </b-button>

                    <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
                        <template #cell(index)="row">
                            {{ row.index + 1 }}
                        </template>
                        <template #cell(dataRefertazione)="item">
                            {{ formatDateTime(item.item.dataRefertazione) }}
                        </template>
                        <template #cell(descrizione)="item">
                            <span v-html="item.item.descrizione"> </span>
                        </template>
                        <template v-slot:cell(actions)="{ item }">
                            <print-component :documentRepository="true" :idRisorsa="item.id" :typeButton="'small'"> </print-component>
                            <!--<b-button size="sm" v-b-tooltip.hover title="Visualizza Referto" variant="outline-secondary" @click="onClickView(item)" class="mr-1 no-text">
                                <font-awesome-icon icon="eye" />
                            </b-button>-->
                            <b-button size="sm" variant="outline-success" v-b-tooltip.hover title="Modifica Referto" @click="onClickAggiornaReferto(item)">
                                <font-awesome-icon icon="edit"> </font-awesome-icon>
                            </b-button>
                            <!--<b-button size="sm" v-b-tooltip.hover title="Cancella Referto" variant="outline-danger" @click="onClickDeleteReferto(item)">
                                <font-awesome-icon icon="trash"></font-awesome-icon>
                            </b-button>
                            -->
                        </template>
                    </b-table>
                </div>
            </div>

            <div class="sa-list-component-footer">
                <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
                    <b-col lg="3">
                        <p>Record Totali:{{ rows }}</p>
                    </b-col>
                    <b-col lg="9">
                        <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
                    </b-col>
                </b-row>
            </div>
        </div>
        <rsa-paziente-referto-modal-edit-component ref="mdlPazienteRefertoModalComponent" @saveSuccess="onSaveSuccess"></rsa-paziente-referto-modal-edit-component>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import PrintComponent from "../../../utility/components/PrintComponent.vue";
import RsaPazienteRefertoModalEditComponent from "./RsaPazienteRefertoModalEditComponent.vue";

export default {
    components: { RsaPazienteRefertoModalEditComponent, PrintComponent },
    mixins: [UtilityMixin],
    data() {
        return {
            rows: 0,
            perPage: 50,
            currentPage: 1,
            pathResources: "/rsapazientereferti",
            listKey: 0,
            items: [],
            idAccettazione: "",
            fields: [
                { key: "index", label: "", thStyle: "width: 2rem" },
                { key: "dataRefertazione", label: "Data/Ora Referto" },
                // { key: "descrizione", label: "Descrizione", thStyle: "heigth: 10rem" },
                { key: "actions", label: "", class: "sa-table-column-action-double" },
            ],
        };
    },
    methods: {
        loadData(idAccettazione) {
            let me = this;
            me.idAccettazione = idAccettazione;
            // console.log("Caricamento dati per idAccettazione:", me.idAccettazione);
            UtilityMixin.methods.loadDataResources(me.pathResources, { idAccettazione: me.idAccettazione }, me.loadDataSuccess, me.loadDataError);
        },
        loadDataSuccess(response) {
            let me = this;
            me.items = response.data.data.list;
            me.rows = response.data.rows;
            me.listKey++;
        },
        loadDataError(error) {
            console.error("Errore nel caricamento dei dati:", error);
        },
        onClickNuovaReferto() {
            this.$refs.mdlPazienteRefertoModalComponent.show(this.idAccettazione);
        },
        onSaveSuccess(data) {
            let me = this;
            me.loadData(data.idAccettazione);
        },
        onClickAggiornaReferto(item) {
            this.$refs.mdlPazienteRefertoModalComponent.showModifica(item.id);
        },
    },
};
</script>
